module.exports = __webpack_public_path__ + "static/mcLegacy-21ab4d9fe549b4f7e14b4a3e09694ccd.gif";